import { DraggableModal } from "Component/Modal";

const LoadingModal = ({ open }) => {
  return (
    <DraggableModal size="sm" open={open} toggleModal={() => null}>
      <DraggableModal.Body>
        <div className="text-body-1 font-bold text-center text-xl">
          Memuat Data ...
        </div>
      </DraggableModal.Body>
    </DraggableModal>
  );
};

LoadingModal.displayName = "LoadingModal";
export { LoadingModal };
